import RpcResponse from "@/core/services/Rpc/RpcResponse";
import ProductionSite from "@/domains/ProductionSites/ProductionSite";
import Core from "@/core/Core";
import FeedRecord from "@/core/services/Feeds/FeedRecord";
import Qty from "@/core/types/Qty";

export default class ProductionPlansDAO {
  static async getList(
    filters?: {
      productionSite?: ProductionSite,
      productCode?: string,
      productName?: string
    }
  ): Promise<RpcResponse> {
    return await Core.rpc.makeRequest(
      'productionPlans.getList',
      {
        ...filters,
        productionSite: filters?.productionSite ? { id: filters.productionSite.id } : undefined,
      }
      );
  }

  static async getActualPlans(): Promise<RpcResponse> {
    return await Core.rpc.makeRequest('productionPlans.getActualPlans');
  }

  static async getProductName(
    filters: {
      code: string
    }
  ): Promise<RpcResponse> {
    return await Core.rpc.makeRequest('productionPlans.getProductName', filters);
  }

  static async addProducts(
    filters: {
      productionSiteId: string,
      productCode: string,
      data: any
    }
  ): Promise<RpcResponse> {
    return await Core.rpc.makeRequest('productionPlans.addProducts', filters);
  }

  static async updateProductQty(
    filters: {
      id: number,
      qty: Qty
    }
  ): Promise<RpcResponse> {
    return await Core.rpc.makeRequest('productionPlans.updateProductQty', filters);
  }

  static async deleteProduct(
    filters: {
      productCode: string,
      productionSite: { id: string },
    }
  ): Promise<RpcResponse> {
    return await Core.rpc.makeRequest(
      'productionPlans.deleteProduct',
      {
        ...filters,
        productionSite: filters?.productionSite ? { id: filters.productionSite.id } : undefined,
      }
    );
  }

  static async getProductLogs(
    filters: {
      productCode: string,
      plannedArrivalDate?: string
    }
  ): Promise<RpcResponse> {
    return await Core.rpc.makeRequest('productionPlans.getProductLogs', filters);
  }

  static async exportLogs(
    filters: {
      logsTitle: string,
      logs: FeedRecord[]
    }
  ): Promise<RpcResponse> {
    return await Core.rpc.makeRequest('productionPlans.exportLogs', filters);
  }

  static async checkProductsExist(
    filters: {
      products: any[]
    }
  ): Promise<RpcResponse> {
    return await Core.rpc.makeRequest('productionPlans.checkProductsExist', filters);
  }

}
